import { ECustomerAccountStatus, EKybStatus, zSchema } from "@zeal/common";

const stringOrBoolean = zSchema
  .string()
  .or(zSchema.boolean())
  .transform((v) => (typeof v === "string" ? v === "true" : v));

export const getCustomerAccountsRequestSchema = zSchema.object({
  company_id: zSchema.string(),
  partner_id: zSchema.string(),
  bank_account_verified: stringOrBoolean.optional(),
  kyb_status: zSchema.nativeEnum(EKybStatus).optional(),
  onboarded: stringOrBoolean.optional(),
  status: zSchema.nativeEnum(ECustomerAccountStatus).optional(),
  q: zSchema.string().optional(),
});

export type TGetCustomerAccountsRequestSchema = zSchema.infer<
  typeof getCustomerAccountsRequestSchema
>;
